import SearchIcon from "assets/icons/SearchIcon";
import ObjectIcon from "assets/icons/ObjectIcon";
import ImageIcon from "assets/icons/imageIcon";

import type { ModelPack } from "vl-api/vlSchemas";

export enum MODEL_PACK {
  VL_LARGE = "VL_LARGE",
  VL_MINI = "VL_MINI",
  VL_ANALYST = "VL_ANALYST",
}

export function isModelPack(value: string): value is ModelPack {
  return (
    value === MODEL_PACK.VL_MINI ||
    value === MODEL_PACK.VL_LARGE ||
    value === MODEL_PACK.VL_ANALYST
  );
}

export const INDEX_CAPABILITY = {
  "i-s": { icon: <ImageIcon />, text: "Image-based search" },
  "t-s": { icon: <SearchIcon />, text: "Text-based search" },
  "e-i": { icon: <ObjectIcon />, text: "Enhanced Image-based search" },
  "e-s": { icon: <SearchIcon />, text: "Enhanced Text-based search" },
  "i-t": { icon: <ImageIcon />, text: "Image AND text based search" },
  "d-o": { icon: <SearchIcon />, text: "Dedicated Defence object detection" },
} as const;

export const INDEX_CAPABILITY_TYPES = {
  "e-e": "• Everyday image exploration",
  "c-c": "• Fast and cost-effective processing of large datasets",
  "d-a": "• Deep analysis and exploration",
  "i-a": "• Identifying small or subtle objects",
  "s-d":
    "Explore and surface defense-related entities such as specific people of interest, weapons and vehicles",
} as const;

type Capability = keyof typeof INDEX_CAPABILITY;
type CapabilityType = keyof typeof INDEX_CAPABILITY_TYPES;

export interface IndexType {
  id: ModelPack;
  name: string;
  capabilities: Capability[];
  capabilitiesTypes: CapabilityType[];
  disabled?: boolean;
}

export const INDEX_TYPES: IndexType[] = [
  {
    id: MODEL_PACK.VL_LARGE,
    name: "VL Large",
    capabilitiesTypes: ["d-a", "i-a"],
    capabilities: ["e-i", "e-s"],
  },
  {
    id: MODEL_PACK.VL_MINI,
    name: "VL Mini",
    capabilities: ["i-s", "t-s"],
    capabilitiesTypes: ["e-e", "c-c"],
  },
  {
    id: MODEL_PACK.VL_ANALYST,
    name: "VL Analyst",
    capabilities: ["i-t", "d-o"],
    capabilitiesTypes: ["s-d"],
  },
];
